export default __webpack_public_path__ + "fonts/plan-lead-automator.svg";